var React = require('react');

function BlobInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M135 321C-28.5124 457.26 228 418 0 659V0H270C298.5 19 284 33.5 228 80C172 126.5 207 261 135 321Z","fill":"#FFE4E4"}));
}

BlobInline.defaultProps = {"width":"285","height":"659","viewBox":"0 0 285 659","fill":"none","preserveAspectRatio":"none"};

module.exports = BlobInline;

BlobInline.default = BlobInline;
